import { CompanyTitledPage } from "../../TitledPage";
import StaffStockTable from "./StaffStockTable";
import useStaffStockPageInfo from "./hooks/useStaffStockPageInfo";
import StaffStockSearchForm from "./StaffStockSearchForm";
import StaffStockTotalDateForm from "./StaffStockTotalDateForm";
import { Button } from "@mui/material";
import LoadingModal from "../../../components/LoadingModal";
import PrintPreview from "../../invoice/PrintManagePage/PrintPreview";
import ResetConfirmDialog from "./ResetConfirmDialog";
import { useResetConfirmDialog } from "./hooks/useResetConfirmDialog";
import useSelectedStocks from "./hooks/useSelectedStock";

export default function StaffStockPage() {
  const staffStockPageInfo = useStaffStockPageInfo();

  const selectedStocks = useSelectedStocks();

  const resetConfirmDialog = useResetConfirmDialog();

  /**
   * 選択された在庫があった時、選択リセットの確認画面を出して確認を求める。
   * @param onAccepted 確認の結果、承諾された場合の挙動
   * @param onRefused 確認の結果、拒否された場合の挙動
   * @param onSkippedConfirm 確認をスキップした(=選択した在庫が1行もない)場合の挙動
   */
  const confirmOnSearchWhenSelectingStocks = (
    onAccepted = () => {},
    onRefused = () => {},
    onSkippedConfirm = onAccepted,
  ) => {
 
    if (!selectedStocks.hasSelectedStocks()) {
      onSkippedConfirm();  
      return;
    }
    
    resetConfirmDialog.setCallbacks({
      reset: () => {
        selectedStocks.clear();
        onAccepted();
      },
      return : onRefused,
    })

    resetConfirmDialog.openDialog();
  }


  const submitAvailableStock = async () => {
    selectedStocks.saveAvailabilities(
      () => {
        staffStockPageInfo.search();
        selectedStocks.clear();
        alert("非表示を更新しました。");
      },
      (e) => {
        console.log(e);
        alert("非表示の更新に失敗しました。");
      }
    )
  }

  const handleChangeTotalDate = async (totalDate) => {

    staffStockPageInfo.searchCondition.update("totalDate", totalDate);
    
    confirmOnSearchWhenSelectingStocks(
      async () => {await staffStockPageInfo.changeTotalDate(totalDate)},
      staffStockPageInfo.resetToPreviousSearchCondition
    );
    
  }

  const handleClickSearch = async (_e) => {
    
    confirmOnSearchWhenSelectingStocks(
      async () => {staffStockPageInfo.search()},
      staffStockPageInfo.resetToPreviousSearchCondition
    );
    
  }

  const handleClickPrintQr = async (_e) => {
    try {
      staffStockPageInfo.printStockQR(
        selectedStocks.getSelectedSalesRecordNos()
      );
    }
    catch (err) {
      console.error(err);
      alert("販売原票QRの出力に失敗しました");
    } 
  }

  const noStocksSelected = !selectedStocks.hasSelectedStocks();
 
  return (
    <CompanyTitledPage title="担当者別在庫一覧" hideCurrentTime>
      <StaffStockTotalDateForm
        searchCondition={staffStockPageInfo.searchCondition}
        changeTotalDate={handleChangeTotalDate}
      />
      <StaffStockSearchForm
        searchCondition={staffStockPageInfo.searchCondition}
        search={handleClickSearch}
      />
      <div style={{ textAlign: 'right' }}>
        <Button
          variant="contained"
          color="error"
          onClick={submitAvailableStock}
          style={{ marginTop: '5mm', marginRight: '5mm' }}
          disabled={noStocksSelected}
        >
          表示/非表示を切替
        </Button>
        <Button
          variant="outlined"
          onClick={(e) => staffStockPageInfo.printStaffStock()}
          style={{ marginTop: '5mm' , marginRight: '5mm'}} 
        >
          担当者別在庫一覧印刷
        </Button>
        <Button
          variant="contained"
          onClick={handleClickPrintQr}
          style={{ marginTop: '5mm' }}
          disabled={noStocksSelected}
        >
          在庫QR印刷
        </Button>
      </div>
      
      <StaffStockTable
        staffStockInfoList={staffStockPageInfo.staffStockInfoList}
        pagination={staffStockPageInfo.pagination}
        movePage={staffStockPageInfo.movePage}
        searchedCondition={staffStockPageInfo.searchedCondition}
        selectedStocks={selectedStocks}
      />

      <LoadingModal label="取得中" open={staffStockPageInfo.isLoading} />
      <PrintPreview printPreview={staffStockPageInfo.printPreview} />
      <ResetConfirmDialog
        {...resetConfirmDialog.dialogParams}
      />
    </CompanyTitledPage>
  );
}
